export default __webpack_public_path__ + "static/media/property_806.6ff59995.png";